function shuffle(array) {
	var currentIndex = array.length,
		temporaryValue,
		randomIndex;
	while (0 !== currentIndex) {
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	return array;
}

function cardArray(values, suits) {
	let arr = [];
	for (let value of values) {
		for (let suit of suits) {
			// Push cards one by one to arr
			arr.push([value, suit]);
		}
	}
	return arr;
}
// Reset game
function dealCards(game) {
	// console.log("HERE IS THE GAME");
	// console.log(game);
	// console.log("HERE ARE THE VALUES");
	// console.log(game.settings);

	// Initialize object
	const cards = {};

	// 1. Add an empty object for each value to cards
	game.settings.values.forEach(value => {
		cards[value] = {};
	});

	// 2. Create a shuffled array of cards, e.g [ ['six', 'diamonds], ['king', 'clubs'], ['queen', 'hearts'], etc ]
	let deck = shuffle(cardArray(game.settings.values, game.settings.suits));

	// 3. Deal cards to players one-by-one.
	// For each card in array
	deck.forEach((card, index) => {
		// Get value and suit
		let value = card[0],
			suit = card[1];

		// Assign suit
		cards[value][suit] = index % game.settings.numPlayers;
	});

	return cards;
}

module.exports = {
	dealCards,
	shuffle,
};
